<template>
  <div v-if="orderDrawer">
    <a-drawer
      :visible="orderDrawer"
      class="authAccount"
      title="订单详情"
      width="1200px"
      placement="right"
      @close="orderDrawer = false"
      :bodyStyle="{ overflow: 'auto', height: 'calc(100% - 161px)' }"
    >
      <a-spin :spinning="spinning_detail" tip="加载中...">
        <div class="searchResult">
          <span class="name">{{ order_detail.name }}</span>
          <div class="tags-container">
            <span class="info-item">千川户ID：{{ advertiser_id }}</span>
            <span
              class="ad-tag tag green"
              v-if="order_detail.status == 'DELIVERY_OK'"
              >投放中</span
            >
            <span class="ad-tag tag red" v-else>
              {{ getStatusName(order_detail.status) }}</span
            >
            <span class="ad-tag tag">千川计划ID: {{ order_detail.ad_id }}</span>
          </div>
        </div>

        <a-tabs
          :default-active-key="detailTab"
          @change="changeDetailTopTab"
          :tabBarStyle="{
            display: 'flex',
            justifyContent: 'flex-start',
            position: 'relative',
          }"
        >
          <a-tab-pane tab="概览" key="1">
            <div class="title">数据概览</div>
            <div class="board-list">
              <div class="overview-board">
                <div class="inner">
                  <p class="metric">消耗(元)</p>
                  <p class="value">{{ ad.stats_info.stat_cost }}</p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">整体支付ROI</p>
                  <p class="value">
                    {{ ad.stats_info.total_prepay_and_pay_order_roi2 }}
                  </p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">整体成交金额</p>
                  <p class="value">
                    {{ ad.stats_info.total_pay_order_gmv_for_roi2 }}
                  </p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">整体成交订单数</p>
                  <p class="value">
                    {{ ad.stats_info.total_pay_order_count_for_roi2 }}
                  </p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">整体成交订单成本</p>
                  <p class="value">
                    {{ ad.stats_info.total_cost_per_pay_order_for_roi2 }}
                  </p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">智能优惠券金额</p>
                  <p class="value">
                    {{ ad.stats_info.total_pay_order_coupon_amount_for_roi2 }}
                  </p>
                </div>
              </div>

              <div class="overview-board">
                <div class="inner">
                  <p class="metric">未完结预售订单金额</p>
                  <p class="value">
                    {{
                      ad.stats_info.total_unfinished_estimate_order_gmv_for_roi2
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="title">数据趋势</div>
            <div>
              <div class="yAxis">
                <div>
                  <section class="yAxis1" />
                  <a-select
                    v-model="adlineChartData.yAxis1"
                    style="width: 150px"
                    placeholder="请选择"
                    @change="adchangeAxis1"
                  >
                    <a-select-option
                      v-for="item in adyAxis1options"
                      :key="item.value"
                      :value="item.value"
                      :disabled="item.disabled"
                    >
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </div>
                <div>
                  <section class="yAxis2" />
                  <a-select
                    v-model="adlineChartData.yAxis2"
                    style="width: 150px"
                    placeholder="请选择"
                    @change="adchangeAxis2"
                  >
                    <a-select-option
                      v-for="item in adyAxis2options"
                      :key="item.value"
                      :value="item.value"
                      :disabled="item.disabled"
                    >
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </div>
              </div>
              <a-spin :spinning="adloading" tip="加载中...">
                <line-chart :chart-data="adlineChartData" />
              </a-spin>
              
            </div>

            <div class="title">详细数据</div>
            <div class="board-list">
              <a-table
                  ref="inOrderTable"
                  :columns="adcolumns"
                  :data-source="adtableData"
                  :pagination="false"
                  :scroll="{ y: 400 }"
                  :rowKey="(record) => record.id || record.ad_id"
                >
                </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="创意" key="2">
            <div class="row">
              <a-radio-group
                :value="material_type"
                @change="handleMaterialTypeChange"
              >
                <a-radio-button value="VIDEO"> 视频 </a-radio-button>
                <a-radio-button
                  value="IMAGE"
                  v-if="order_detail.marketing_goal == 'VIDEO_PROM_GOODS'"
                >
                  图片
                </a-radio-button>
                <a-radio-button
                  value="LIVE_ROOM"
                  v-if="order_detail.marketing_goal == 'LIVE_PROM_GOODS'"
                >
                  直播间画面
                </a-radio-button>
                <a-radio-button value="TITLE"> 标题 </a-radio-button>
              </a-radio-group>

              <a-input-search
                v-model="search_keyword"
                :allowClear="true"
                style="margin-left: 10px; width: 240px"
                placeholder="输入视频名称/ID"
                enter-button
                @search="getAdMaterial"
              />

              <a-select
                v-model="material_status"
                style="width: 120px; margin-left: 10px"
                @change="handleStatusChange"
              >
                <a-select-option value="ALL">全部</a-select-option>
                <a-select-option value="DELIVERY_OK">投放中</a-select-option>
                <a-select-option value="DELETED">已删除</a-select-option>
              </a-select>

              <a-range-picker
                style="width: 240px; margin-left: 10px"
                :value="range_date"
                @change="onTimeChange"
                class="filterItem"
                showToday
                :placeholder="['开始时间', '结束时间']"
              />

              <a-button
                class="btn"
                type="primary"
                @click="addMaterial"
                icon="plus"
                v-if="material_type == 'VIDEO'"
                >批量补素材</a-button
              >
              <a-button
                class="btn"
                type="primary"
                :disabled="true"
                icon="plus"
                v-if="material_type == 'TITLE'"
                >批量补标题</a-button
              >
              <a-button
                class="btn"
                type="danger"
                icon="delete"
                style="margin-left: 10px"
                :disabled="selectedRowKeys.length === 0"
                @click="batchDeleteMaterial"
                >批量删除创意</a-button
              >
            </div>
            <div class="board-list">
              <a-table
                style="width: 100%"
                :columns="material_columns"
                :pagination="pagination"
                :data-source="material_data"
                :rowKey="
                  (record, index) => {
                    return index;
                  }
                "
                :sortDirections="['descend', 'ascend', '']"
                @change="handleTableChange"
                :scroll="{ x: 1200, y: 'calc(56vh)' }"
                :rowSelection="{
                  selectedRowKeys: selectedRowKeys,
                  onChange: onSelectChange,
                }"
              >
                <div class="aweme" slot="info" slot-scope="text">
                  <div
                    class="aweme-left"
                    v-if="
                      text?.material_info?.video_material?.cover_image
                        ?.image_url ||
                      text?.material_info?.image_material?.image_url
                    "
                  >
                    <img
                      class="videoimg"
                      :src="
                        text?.material_info?.video_material?.cover_image
                          ?.image_url ||
                        text?.material_info?.image_material?.image_url
                      "
                      style="width: 40px; height: 50px"
                    />
                  </div>
                  <div class="aweme-right">
                    <a-tooltip
                      placement="top"
                      :title="
                        text?.material_info?.video_material?.title ||
                        text?.material_info?.title_material?.title
                      "
                    >
                      <div class="aweme-title">
                        {{
                          text?.material_info?.video_material?.title ||
                          text?.material_info?.title_material?.title
                        }}
                      </div>
                    </a-tooltip>
                    <div class="aweme-id small">
                      素材ID：{{ text?.material_id }}
                      <a-icon
                        type="copy"
                        @click="text_copy(text?.material_id)"
                      />
                    </div>
                  </div>
                </div>

                <div slot="material" slot-scope="text">
                  <a-tag
                    color="green"
                    v-if="text?.material_status == 'DELIVERY_OK'"
                    >投放中</a-tag
                  >
                  <a-tag
                    color="red"
                    v-else-if="text?.material_status == 'DELETED'"
                    >已删除</a-tag
                  >
                </div>
                <div slot="status" slot-scope="text">
                  <a-tag color="green" v-if="text?.audit_status == 'PASS'"
                    >审核通过</a-tag
                  >
                  <a-tag color="red" v-else-if="text?.audit_status == 'REJECT'"
                    >审核拒绝</a-tag
                  >
                  <a-tag
                    color=""
                    v-else-if="text?.audit_status == 'IN_PROGRESS'"
                    >审核中</a-tag
                  >
                </div>
                <div
                  style="cursor: pointer; text-align: center"
                  slot="action"
                  slot-scope="text, record"
                >
                  <span
                    slot="action"
                    v-if="text?.material_status != 'DELETED'"
                    class="actionItem"
                    @click="deleteMaterial(record)"
                    style="color: red"
                    >删除</span
                  >
                </div>
              </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="详情" key="3">
            <!-- <div class="title">详情</div> -->
            <div class="oc-detail-bar">
              <div class="oc-detail-bar-text">
                <div class="oc-detail-bar-config-item">
                  营销目标：{{
                    order_detail.marketing_goal == 'VIDEO_PROM_GOODS'
                      ? '推商品'
                      : '推直播'
                  }}
                </div>
                <div class="oc-detail-bar-config-item">
                  推广方式：{{
                    ad.ad_info.smart_bid_type == 'SMART_BID_CUSTOM'
                      ? '控成本投放'
                      : '放量投放'
                  }}
                </div>
              </div>
            </div>

            <div class="config-card-container" style="column-count: 1">
              <div class="oc-promotion-detail-card config-card">
                <div class="oc-promotion-detail-card-header">投放设置</div>
                <div class="oc-promotion-detail-card-body">
                  <div class="oc-promotion-detail-card-body-item">
                    <span
                      >投放方式：{{
                        order_detail?.delivery_setting?.smart_bid_type ==
                        'SMART_BID_CUSTOM'
                          ? '控成本投放'
                          : '放量投放'
                      }}</span
                    >
                  </div>
                  <div class="oc-promotion-detail-card-body-item">
                    <span>优化目标：整体支付ROI</span>
                  </div>

                  <div class="oc-promotion-detail-card-body-item">
                    <span
                      >{{
                        order_detail?.delivery_setting?.budget_mode ==
                        'BUDGET_MODE_DAY'
                          ? '日预算'
                          : '总预算'
                      }}：{{ order_detail?.delivery_setting?.budget }} 元</span
                    >
                  </div>

                  <div class="oc-promotion-detail-card-body-item">
                    <span
                      >智能优惠券：{{
                        order_detail?.delivery_setting?.qcpx_mode ==
                        'QCPX_MODE_ON'
                          ? '启用'
                          : '不启用'
                      }}</span
                    >
                  </div>

                  <div
                    class="oc-promotion-detail-card-body-item"
                    v-if="order_detail?.delivery_setting?.cpa_bid"
                  >
                    <span
                      >出价：{{ order_detail?.delivery_setting?.cpa_bid }}</span
                    >
                  </div>
                  <div
                    class="oc-promotion-detail-card-body-item"
                    v-if="order_detail?.delivery_setting?.roi2_goal"
                  >
                    <span
                      >ROI目标：{{
                        order_detail?.delivery_setting?.roi2_goal
                      }}</span
                    >
                  </div>

                  <div
                    class="oc-promotion-detail-card-body-item"
                    v-if="order_detail.marketing_goal == 'VIDEO_PROM_GOODS'"
                  >
                    <span
                      >投放时间：{{
                        order_detail?.delivery_setting?.video_schedule_type ==
                        'SCHEDULE_FROM_NOW'
                          ? '从今天起长期投放'
                          : '设置开始和结束日期'
                      }}</span
                    >
                  </div>
                  <div
                    class="oc-promotion-detail-card-body-item"
                    v-if="order_detail.marketing_goal == 'LIVE_PROM_GOODS'"
                  >
                    <span
                      >投放时间：{{
                        get_live_schedule_type(
                          order_detail?.delivery_setting?.live_schedule_type
                        )
                      }}</span
                    >
                  </div>
                  <div
                    class="oc-promotion-detail-card-body-item"
                    v-if="
                      order_detail?.delivery_setting?.video_schedule_type ==
                        'SCHEDULE_START_END' ||
                      order_detail?.delivery_setting?.live_schedule_type ==
                        'SCHEDULE_START_END'
                    "
                  >
                    <span
                      >投放时段：{{
                        order_detail?.delivery_setting?.start_time
                      }}
                      ~ {{ order_detail?.delivery_setting?.end_time }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="日志" key="4">
            <!-- <div class="title">日志</div> -->
            <div class="board-list">
              <a-table
                style="width: 100%"
                :columns="log_columns"
                :data-source="log_data"
                :rowKey="
                  (record, index) => {
                    return index;
                  }
                "
              >
                <div slot="content" slot-scope="text">
                  <p v-for="(item, index) in text.content_log" :key="index">
                    {{ item }}
                  </p>
                </div>
              </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="诊断" key="5">
            <!-- <div class="title">诊断</div> -->
            <div class="board-list"></div>
          </a-tab-pane>
          <a-tab-pane tab="操作日志" key="6">
            <a-table
              style="width: 100%"
              :columns="user_log_columns"
              :data-source="user_log_data"
              :rowKey="
                (record, index) => {
                  return index;
                }
              "
            >
            </a-table>
          </a-tab-pane>
          <a-tab-pane tab="监控日志" key="7">
            <a-table
              style="width: 100%"
              :columns="monitor_log_columns"
              :data-source="monitor_log_data"
              :rowKey="
                (record, index) => {
                  return index;
                }
              "
            >
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </a-spin>

      <div class="footer">
        <!-- <a-button type="primary" @click="copyOneAd(ad)">复制计划</a-button> -->
      </div>
    </a-drawer>

    <addVideo
      v-if="videoVisible"
      :advertiser_id="advertiser_id"
      :marketing_goal="order_detail.marketing_goal"
      :aweme_id="order_detail.aweme_id + ''"
      :product_list="product_list"
      :newSelectList="newSelectList"
      @receive="videoreceive"
      @closeAddDrawer="closeAddDrawer"
    />

    <a-modal
      title="提示"
      :visible="resultvisible"
      :footer="null"
      width="700px"
      @cancel="resultvisible = false"
    >
      <a-result
        status="success"
        title="您的补素材任务已创建成功!"
        sub-title="请前往【千川全域】-》【任务管理】,查看任务具体执行进度。"
      >
        <template #extra>
          <a-button key="console" type="primary" @click="resultvisible = false">
            关闭弹窗
          </a-button>
          <a-button key="buy" @click="gotask"> 前往任务列表 </a-button>
        </template>
      </a-result>

      <br />
      <br />
    </a-modal>

    <a-modal
      title="追加创意标题（每行一个，支持换行）"
      :visible="titleModalVisible"
      :z-index="1000001"
      @ok="addMaterialAction"
      :confirm-loading="addloading"
      @cancel="titleModalVisible = false"
      :okText="'确定补' + select_list.length + '条素材'"
    >
      <a-textarea
        v-model="titleInput"
        :rows="4"
        placeholder="每行一个标题，支持换行"
        @input="handleTitleInput"
      />
      <div v-if="titleList.length" style="margin-top: 16px">
        <div
          v-for="(title, idx) in titleList"
          :key="idx"
          style="display: flex; align-items: center; margin-bottom: 8px"
        >
          <span style="flex: 1">{{ title }}</span>
          <a-icon
            type="delete"
            style="color: red; cursor: pointer"
            @click="removeTitle(idx)"
          />
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { qcApi, requestHttp } from '@utils/index';
import moment from 'moment';
import { Modal } from 'ant-design-vue';
import addVideo from '../../../../createPlanNew/components/addVideo.vue';
import { LineChart } from '@components';
const log_columns = [
  {
    title: '操作时间',
    dataIndex: 'create_time',
    key: 'create_time',
    width: 90,
  },
  {
    title: '操作类型',
    dataIndex: 'content_title',
    key: 'content_title',
    width: 90,
  },
  {
    title: '操作内容',
    key: 'content',
    scopedSlots: { customRender: 'content' },
    width: 200,
  },
  {
    title: '操作人',
    dataIndex: 'operator',
    key: 'operator',
    width: 90,
  },
  {
    title: '操作IP',
    dataIndex: 'opt_ip',
    key: 'opt_ip',
    width: 90,
  },
];
const video_columns = [
  {
    title: '创意',
    dataIndex: 'create_time',
    key: 'create_time',
    width: 90,
  },
  {
    title: '审核状态',
    dataIndex: 'content_title',
    key: 'content_title',
    width: 90,
  },
  {
    title: '消耗',
    key: 'content',
    scopedSlots: { customRender: 'content' },
    width: 200,
  },
  {
    title: '展示次数',
    dataIndex: 'operator',
    key: 'operator',
    width: 90,
  },
  {
    title: '点击率',
    dataIndex: 'opt_ip',
    key: 'opt_ip',
    width: 90,
  },
];
const material_columns = [
  {
    title: '创意',
    key: 'info',
    scopedSlots: { customRender: 'info' },
    width: 280,
    fixed: 'left',
  },
  {
    title: '素材状态',
    scopedSlots: { customRender: 'material' },
    key: 'material',
    width: 90,
    fixed: 'left',
  },
  {
    title: '审核状态',
    scopedSlots: { customRender: 'status' },
    key: 'status',
    fixed: 'left',
    width: 90,
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' },
    key: 'action',
    fixed: 'left',
    align: 'center',
    width: 60,
  },
  {
    title: '消耗',
    dataIndex: 'stat_cost_for_roi2',
    key: 'stat_cost_for_roi2',
    align: 'center',
    sorter: true,
    width: 100,
  },
  {
    title: '支付ROI',
    dataIndex: 'total_prepay_and_pay_order_roi2',
    key: 'total_prepay_and_pay_order_roi2',
    align: 'center',
    sorter: true,
    width: 100,
  },
  {
    title: '成交金额',
    dataIndex: 'total_pay_order_gmv_for_roi2',
    key: 'total_pay_order_gmv_for_roi2',
    align: 'center',
    sorter: true,
    width: 100,
  },
  {
    title: '成交订单数',
    dataIndex: 'total_pay_order_count_for_roi2',
    key: 'total_pay_order_count_for_roi2',
    align: 'center',
    sorter: true,
    width: 120,
  },
  {
    title: '成交订单成本',
    dataIndex: 'total_cost_per_pay_order_for_roi2',
    key: 'total_cost_per_pay_order_for_roi2',
    sorter: true,
    width: 120,
  },
  {
    title: '整体成交智能优惠券金额',
    dataIndex: 'total_pay_order_coupon_amount_for_roi2',
    key: 'total_pay_order_coupon_amount_for_roi2',
    width: 90,
  },
];
const user_log_columns = [
  { title: '操作时间', dataIndex: 'createtime', key: 'createtime', width: 90 },
  { title: '操作内容', key: 'content', dataIndex: 'content', width: 200 },
  { title: '操作人', dataIndex: 'nickname', key: 'nickname', width: 90 },
];
const monitor_log_columns = [
  {
    title: '户ID',
    dataIndex: 'advertiser_id',
    key: 'advertiser_id',
    width: 180,
  },
  { title: '计划ID', dataIndex: 'order_id', key: 'order_id', width: 180 },
  { title: '监控类型', dataIndex: 'type_text', key: 'type_text', width: 130 },
  { title: '监控反馈', dataIndex: 'content', key: 'content' },
  { title: '创建时间', dataIndex: 'createtime', key: 'createtime', width: 150 },
];
const adcolumns = [
  {
    title: '时间',
    dataIndex: 'stat_datetime',
    width: 200,
    align: 'center',
    ellipsis: true,
    scopedSlots: { customRender: 'stat_datetime' },
    fixed: 'left',
  },
  {
    title: '消耗（元）',
    dataIndex: 'stat_cost',
    key: 'stat_cost',
    align: 'center',
    width: 130,
  },
  {
    title: '成交金额',
    dataIndex: 'pay_order_amount',
    key: 'pay_order_amount',
    align: 'center',
    width: 130,
  },
  {
    title: '支付ROI',
    dataIndex: 'prepay_and_pay_order_roi',
    key: 'prepay_and_pay_order_roi',
    align: 'center',
    width: 130,
  },
  {
    title: '成交订单数',
    dataIndex: 'pay_order_count',
    key: 'pay_order_count',
    align: 'center',
    width: 130,
  },
];
export default {
  name: 'detail',
  props: {
    advertiser_id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      spinning_detail: false,
      order_detail: {},
      orderDrawer: false,
      detailTab: '1',
      ad: {},
      log_data: [],
      ad_id: '',
      log_columns,
      video_columns,
      video_data: [],
      campaign_scene: '',
      marketing_scene: '',
      material_type: 'VIDEO',
      material_data: [],
      material_columns,
      statusData: [
        { name: '全部计划状态', value: '' },
        { name: '新建审核中', value: 'AUDIT' },
        { name: '已删除', value: 'DELETE' },
        { name: '投放中', value: 'DELIVERY_OK' },
        { name: '已暂停', value: 'DISABLE' },
        { name: '草稿', value: 'DRAFT' },
        { name: '数据错误', value: 'ERROR' },
        { name: '落地页暂不可用', value: 'EXTERNAL_URL_DISABLE' },
        { name: '已终止', value: 'FROZEN' },
        { name: '关联直播间未开播', value: 'LIVE_ROOM_OFF' },
        { name: '不在投放时段', value: 'NO_SCHEDULE' },
        { name: '审核不通过', value: 'OFFLINE_AUDIT' },
        { name: '账户余额不足', value: 'OFFLINE_BALANCE' },
        { name: '广告超出预算', value: 'OFFLINE_BUDGET' },
        { name: '预上线', value: 'PRE_ONLINE' },
        { name: 'QUOTA配额不足暂停计划', value: 'QUOTA_DISABLE' },
        { name: '修改审核中', value: 'REAUDIT' },
        { name: '全域推广暂停', value: 'ROI2_DISABLE' },
        { name: '系统暂停', value: 'SYSTEM_DISABLE' },
        { name: '已完成', value: 'TIME_DONE' },
        { name: '未到达投放时间', value: 'TIME_NO_REACH' },
        { name: '账户超出预算', value: 'ADVERTISER_OFFLINE_BUDGET' },
        { name: '账户接近预算', value: 'ADVERTISER_PRE_OFFLINE_BUDGET' },
        { name: '异常，请联系审核人员', value: 'AUDIT_STATUS_ERROR' },
        { name: '关联抖音号不可投', value: 'AWEME_ACCOUNT_DISABLED' },
        { name: '已被广告组暂停', value: 'CAMPAIGN_DISABLE' },
        { name: '广告组超出预算', value: 'CAMPAIGN_OFFLINE_BUDGET' },
        { name: '广告组接近预算', value: 'CAMPAIGN_PRE_OFFLINE_BUDGET' },
      ],

      user_log_columns,
      user_log_data: [],
      monitor_log_columns,
      monitor_log_data: [],

      material_status: 'DELIVERY_OK',
      search_keyword: '',

      range_date: [
        moment().format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],

      sortby: 'material_id',
      sort: 'descend',
      page: 1,
      pagesize: 10,
      pagination: {
        current: 1,
        pageSize: 100,
        total: 0,
        pageSizeOptions: ['100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        hideOnSinglePage: false,
        showQuickJumper: true,
        showSizeChanger: true,
      },
      videoVisible: false,
      product_list: {
        id: '',
      },
      newSelectList: [],
      materialList: [],
      resultvisible: false,
      titleModalVisible: false,
      titleInput: '',
      titleList: [],
      select_list: [],
      addloading: false,
      selectedRowKeys: [],
      selectedRows: [],
      adlineChartData: {
        expectedData: [],
        actualData: [],
        yAxis1: '0',
        yAxis2: '1',
        xAxisdata: [],
      },
      adloading: false,
      adtableData: [],
      adcolumns,
      adyAxis1options: [
        {
          value: '0',
          name: 'stat_cost',
          label: '消耗',
          disabled: false,
        },
        {
          value: '1',
          name: 'pay_order_amount',
          label: '成交金额',
          disabled: true,
        },
        {
          value: '2',
          name: 'prepay_and_pay_order_roi',
          label: '支付ROI',
          disabled: false,
        },
        {
          value: '3',
          name: 'pay_order_count',
          label: '成交订单数',
          disabled: false,
        },
      ],
      adyAxis2options: [
        {
          value: '0',
          name: 'stat_cost',
          label: '消耗',
          disabled: true,
        },
        {
          value: '1',
          name: 'pay_order_amount',
          label: '成交金额',
          disabled: false,
        },
        {
          value: '2',
          name: 'prepay_and_pay_order_roi',
          label: '支付ROI',
          disabled: false,
        },
        {
          value: '3',
          name: 'pay_order_count',
          label: '成交订单数',
          disabled: false,
        },
      ],
      adyAxis1name: 'stat_cost',
      adyAxis2name: 'pay_order_amount',
    };
  },

  components: {
    addVideo,
    LineChart,
  },

  watch: {},

  mounted() {},
  methods: {
    gotask() {
      this.$router.replace('/qy_task');
    },
    addMaterial() {
      this.newSelectList = [];
      if (this.order_detail.multi_product_creative_list.length > 1) {
        this.$message.error('当前仅支持一个商品的计划补充素材');
        return;
      }
      this.materialList = [];
      if (this.material_data.length > 0) {
        for (let i = 0; i < this.material_data.length; i++) {
          const item = this.material_data[i];
          this.materialList.push({
            advertiser_id: this.advertiser_id,
            filename: item?.material_info?.video_material?.title,
            duration: item?.material_info?.video_material?.video_duration,
            id: item?.material_info?.video_material?.video_id,
            imageUrl:
              item?.material_info?.video_material?.cover_image.image_url,
            image_mode: 'VIDEO_VERTICAL',
            type: 'VIDEO',
            video_title: item?.material_info?.video_material?.title,
            source: 'QIANCHUAN',
            material_id: item?.material_id,
            video_cover_url:
              item?.material_info?.video_material?.cover_image.image_url,
            url: item?.material_info?.video_material?.url,
          });
        }
      }
      this.videoVisible = true;
    },
    videoreceive(value) {
      // 选中的视频
      console.log('选中的视频千川', value);
      //过滤
      let select_list = [];
      if (value.video_material_list.length > 0) {
        for (let i = 0; i < value.video_material_list.length; i++) {
          const item = value.video_material_list[i];
          console.log('item.source', item.source);
          if (item.source == 'DOUYIN') {
            let dd = [];
            if (
              this.order_detail.programmatic_creative_media_list.video_material
            ) {
              dd =
                this.order_detail.programmatic_creative_media_list.video_material.filter(
                  function (it) {
                    return it.aweme_item_id == item.id && it.aweme_item_id > 0;
                  }
                );
            }
            console.log('dd', dd);
            if (dd.length == 0) {
              select_list.push(item);
            }
          } else if (item.source == 'QIANCHUAN') {
            let dd = [];
            if (
              this.order_detail.programmatic_creative_media_list.video_material
            ) {
              dd =
                this.order_detail.programmatic_creative_media_list.video_material.filter(
                  function (it) {
                    return it.video_id == item.id && it.aweme_item_id == 0;
                  }
                );
            }
            if (dd.length == 0) {
              select_list.push(item);
            }
          } else if (item.source == 'LIANSHAN') {
            select_list.push(item);
          }
        }
        console.log('select_list-----------', select_list);
        if (select_list.length == 0) {
          this.$message.error('过滤完无可用素材');
          return;
        }
        //判断是否有抖音下素材或者是否有标题素材
        // Modal.confirm({
        //   title: '删除提醒',
        //   content: '已过滤重复素材，是否确定向该计划下追加【'+select_list.length+'】条素材？',
        //   onOk: () => {
        //     this.addMaterialAction(select_list)
        //   },
        // });
        this.select_list = select_list;
        this.titleModalVisible = true;
        this.titleInput = '';
        this.titleList = [];
      } else {
        this.$message.error('请选择视频');
      }
    },
    handleTitleInput(e) {
      this.titleInput = e.target.value;
      // 按行分割，去除空行
      this.titleList = this.titleInput
        .split('\n')
        .map((t) => t.trim())
        .filter((t) => t);
    },
    removeTitle(index) {
      this.titleList.splice(index, 1);
      // 同步回textarea
      this.titleInput = this.titleList.join('\n');
    },
    handleTitleModalOk() {
      // 这里可以将titleList提交到后端或做后续处理
      this.titleModalVisible = false;
    },
    async addMaterialAction() {
      const that = this;
      this.addloading = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.ADD_QY_AD_LIVE_MATERIAL}`,
        method: 'POST',
        params: {
          advertiser_id: that.advertiser_id,
          ad_id: that.order_detail.ad_id,
          marketing_goal: that.order_detail.marketing_goal,
          select_list: JSON.stringify(this.select_list),
          titleList: this.titleList.length > 0 ? this.titleList : '',
          aweme_id: that.order_detail.aweme_id,
          aweme_name: that.ad?.room_info[0]?.anchor_name,
          aweme_avatar: that.ad?.room_info[0]?.anchor_avatar,
        },
      });
      this.addloading = false;
      if (code == 0) {
        that.$message.error(msg);
        return;
      }
      this.resultvisible = true;
      this.videoVisible = false;
      this.titleModalVisible = false;
    },
    closeAddDrawer() {
      this.videoVisible = false;
    },
    deleteMaterial(e) {
      const that = this;
      Modal.confirm({
        title: '删除提醒',
        content: '是否确定删除素材？',
        onOk: async () => {
          await that.deleteMaterialAction(e);
        },
      });
    },
    async deleteMaterialAction(e) {
      const that = this;
      let opt_status = 'DELETE';
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.STOP_QY_AD_MATERIAL}`,
        method: 'POST',
        params: {
          advertiser_id: that.advertiser_id,
          ad_id: that.ad_id,
          material_type: that.material_type,
          material_id: e.material_id,
        },
      });
      if (code == 0) {
        that.$message.error(msg);
        return;
      }
      that.$message.success(msg);
      that.getAdMaterial();
    },
    handleTableChange(e, filters, sorter) {
      console.log('点击了', sorter);

      // 检查排序条件是否发生变化
      const sortChanged =
        sorter.order &&
        (this.sort !== sorter.order || this.sortby !== sorter.columnKey);

      // 设置排序参数
      if (sorter.order) {
        this.sort = sorter.order;
        this.sortby = sorter.columnKey;
      } else {
        this.sort = 'descend';
        this.sortby = 'material_id';
      }

      // 只有在排序条件改变时才重置页码
      if (sortChanged) {
        this.page = 1;
        this.pagination = {
          ...e,
          current: 1,
        };
      } else {
        // 正常分页逻辑
        this.page = e.current;
        this.pagination = e;
      }

      this.pagesize = e.pageSize;
      this.getAdMaterial();
    },
    handleStatusChange(e) {
      this.material_status = e;
      this.getAdMaterial();
    },
    onTimeChange(e, date) {
      this.range_date = date;
      this.getAdMaterial();
    },
    // 复制操作
    text_copy(context) {
      navigator.clipboard
        .writeText(context)
        .then(() => {
          this.$message.success('复制成功');
        })
        .catch((err) => {
          this.$message.error('复制失败');
        });
    },
    get_live_schedule_type(type) {
      let live_schedule_type = '';
      switch (type) {
        case 'SCHEDULE_FROM_NOW':
          live_schedule_type = '从今天起长期投放';
          break;
        case 'SCHEDULE_START_END':
          live_schedule_type = '设置开始和结束日期';
          break;
        case 'SCHEDULE_TIME_FIXEDRANGE':
          live_schedule_type = '固定时长';
          break;
        default:
          break;
      }
      return live_schedule_type;
    },
    getStatusName(status) {
      const statusItem = this.statusData.find((item) => item.value === status);
      return statusItem ? statusItem.name : status;
    },
    async getAdDetail(e) {
      this.detailTab = '1';
      this.ad_id = e.ad_info.id;
      this.orderDrawer = true;
      this.spinning_detail = true;
      console.log('参数', e);
      this.ad = e;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QY_AD_DETAIL}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          ad_id: e.ad_info.id,
        },
      });
      this.spinning_detail = false;
      if (code == 0) {
        this.orderDrawer = false;
        this.$message.error(msg);
        return;
      }
      this.order_detail = data;
      this.initAdEchart();
    },
    initAdEchart() {
      // 初始化趋势数据
      if (this.ad && this.ad.ad_info) {
        this.adlineChartData.yAxis1 = this.adyAxis1options[0].value;
        this.adyAxis1name = this.adyAxis1options[0].name;
        this.adlineChartData.yAxis2 = this.adyAxis2options[1].value;
        this.adyAxis2name = this.adyAxis2options[1].name;
        this.echartOrder();
      }
    },
    adchangeAxis1(val) {
      const selectedOption = this.adyAxis1options.find(item => item.value === val);
      if (selectedOption) {
        this.adlineChartData.yAxis1 = selectedOption.label;
        this.adyAxis1name = selectedOption.name;
        this.adyAxis2options.forEach(function (item) {
          if (item.value === val) {
            item.disabled = true;
          } else {
            item.disabled = false;
          }
        });
        this.echartOrder();
      }
    },
    adchangeAxis2(val) {
      const selectedOption = this.adyAxis2options.find(item => item.value === val);
      if (selectedOption) {
        this.adlineChartData.yAxis2 = selectedOption.label;
        this.adyAxis2name = selectedOption.name;
        this.adyAxis1options.forEach(function (item) {
          if (item.value === val) {
            item.disabled = true;
          } else {
            item.disabled = false;
          }
        });
        this.echartOrder();
      }
    },
    async echartOrder() {
      if (!this.ad || !this.ad.ad_info) {
        return;
      }
      this.adloading = true;
      
      // 获取时间范围
      let start_date = this.range_date[0] ? this.range_date[0] : '';
      let end_date = this.range_date[1] ? this.range_date[1] : '';
      
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.QY_AD_REPORT_ECHART}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          ad_id: this.ad.ad_info.id,
          order_create_time: this.order_detail?.create_time,
          y1: this.adyAxis1name,
          y2: this.adyAxis2name,
          start_date: start_date,
          end_date: end_date,
        },
      });
      this.adloading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) return;
      this.adlineChartData.xAxisdata = data.x || [];
      this.adlineChartData.actualData = data.y1 || [];
      this.adlineChartData.expectedData = data.y2 || [];
      this.adtableData = data.list || [];
    },
    async getAdLogs() {
      this.spinning_detail = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.QC_GET_AD_LOGS}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          ad_id: this.ad_id,
        },
      });
      this.spinning_detail = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.log_data = data.logs;
    },
    handleMaterialTypeChange(e) {
      this.material_type = e.target.value;
      this.page = 1;
      this.getAdMaterial();
    },
    async getAdMaterial() {
      this.spinning_detail = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.QY_GET_AD_MATERIAL}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          ad_id: this.ad_id,
          marketing_goal: this.order_detail.marketing_goal,
          aweme_id: this.order_detail.aweme_id,
          material_type: this.material_type,
          search_keyword: this.search_keyword,
          material_status: this.material_status,
          start_date: this.range_date[0] ? this.range_date[0] : '',
          end_date: this.range_date[1] ? this.range_date[1] : '',
          sortby: this.sortby,
          sort: this.sort,
          page: this.page,
          pagesize: 100,
        },
      });
      this.spinning_detail = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.material_data = data.ad_material_infos;
      this.pagination.total = data.page_info.total_number;
    },
    async getUserLog() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_USER_LOGLIST}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          other_id: this.order_detail.ad_id,
          page: 1,
          pagesize: 100,
        },
      });
      this.loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return;
      this.user_log_data = data.list;
    },
    async getMonitorLog() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QY_MONITOR_LOG_LIST}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          order_id: this.order_detail.ad_id,
          page: 1,
          pagesize: 100,
        },
      });
      this.loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return;
      this.monitor_log_data = data.list;
    },
    changeDetailTopTab(e) {
      this.detailTab = e;
      if (e == 2) {
        this.getAdMaterial();
      } else if (e == 4) {
        this.getAdLogs();
      } else if (e == 6) {
        this.getUserLog();
      } else if (e == 7) {
        this.getMonitorLog();
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    async batchDeleteMaterial() {
      if (!this.selectedRows.length) return;
      const that = this;
      Modal.confirm({
        title: '批量删除提醒',
        content: `是否确定批量删除选中的${this.selectedRows.length}个创意？`,
        onOk: async () => {
          for (let row of that.selectedRows) {
            // 只删除未被标记为DELETED的
            if (row?.info?.material_status !== 'DELETED') {
              await that.deleteMaterialAction(row);
            }
          }
          that.selectedRowKeys = [];
          that.selectedRows = [];
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.searchResult {
  .name {
    color: #333;
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
  }
}

.aweme {
  display: flex;
  padding-left: 20px;
}

.aweme-right {
  text-align: left;
  padding-left: 10px;

  .aweme-title {
    color: #323335;
    // font-weight: bold;
    // margin-bottom: 5px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 180px;
  }
}

.small {
  font-size: 11px;
  line-height: 18px;
}

.tips {
  margin-bottom: 10px;
}

.showTemplate {
  .dataOverview {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 0;
  }

  .dataViewItem {
    flex: 1;
    margin-right: 0.5%;
    margin-left: 0.5%;
    border-radius: 15px;
    float: left;
    box-shadow: 0 2px 8px #00000026;
    margin-bottom: 10px;
    overflow: hidden;
    height: 120px;

    div {
      text-align: left;
      color: #333;
      font-size: 18px;
      padding-top: 20px;
      padding-left: 20px;
    }

    p {
      font-size: 24px;
      padding-top: 5px;
      font-weight: bold;
    }
  }
}

.copy-icon {
  height: 100px;
  border-radius: 5px;
  cursor: pointer;
}

.rowOperate {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .actionItem {
    margin-left: 10px;
    color: #597ef7;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }
}

.filterCondition {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  span {
    margin-left: 20px;
  }

  // .createBtn {
  //   margin-left: 20px;
  // }
}

.tags-container {
  padding: 16px 0px;
  overflow: hidden;
}

.tags-container .ad-tag {
  float: left;
  margin-left: 16px;
}

.tags-container .ad-tag:first-child {
  margin-left: 0;
}

.tags-container .inbl {
  display: inline-block;
  vertical-align: middle;
}

.tags-container .roi-input {
  position: relative;
  top: 1px;
}

.tags-container .roi-target-box {
  display: inline-block;
  margin-left: 24px;
}

.tags-container .info-item {
  float: left;
  height: 26px;
  //  margin-left:24px;
  position: relative;
  display: flex;
}

.avatar {
  widows: 26px;
  height: 26px;
  border-radius: 50%;
  margin-right: 5px;
}

.tags-container .info-item.editable {
  padding-right: 28px;
}

.tags-container .info-item .content {
  display: inline-block;
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tags-container .info-item .content .nobid-bid-content {
  color: #999;
}

.tag {
  background: #f2f2f2;
  border-radius: 4px;
  color: #999;
  font-size: 14px;
  line-height: 22px;
  padding: 2px 8px;
}

.tag.red {
  background: #fff1ef;
  color: #e5453f;
}

.tag.gray {
  background: #f2f2f2;
  color: #999;
}

.tag.green {
  background: #e6f8ee;
  color: #34ba7b;
}

.copynum {
  font-weight: bold;
  color: red;
}

.product-item {
  display: flex;
  height: 56px;
  margin-top: 8px;
}

.product-item .good {
  padding-left: 0;
}

.product-item .icon {
  border-radius: 4px;
  height: 56px;
  width: 56px;
}

.product-item .info {
  padding-top: 3px;
}

.product-item .info .name {
  font-size: 14px;
  height: 22px;
  line-height: 22px;
  margin: 0 0 8px 16px;
}

.product-item .info .id,
.product-item .info .price {
  color: #999;
  display: inline-block;
  font-size: 12px;
  line-height: 20px;
  padding: 0 16px;
}

.product-item .info .separator {
  border-right: 1px solid #999;
  display: inline-block;
  height: 8px;
  position: relative;
}

.product-item .info .price-num {
  color: #333;
  margin-left: 8px;
}

.ad-drawer__aweme-info {
  border-bottom: 1px solid #ebebeb;
  padding-bottom: 16px;
}

.title {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  line-height: 34px;
}

.board-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 21px;
  min-width: 932px;

  .overview-board {
    background: #f2f2f2;
    background-color: #f2f2f2;
    margin: 0 10px 10px 0;
    border-radius: 8px;
    cursor: pointer;
    height: 108px;
    width: 175px;

    .inner {
      border-radius: 4px;
      padding: 12px 12px 17px;

      .metric {
        color: #252729;
        font-size: 14px;
        font-weight: 600;
        height: 20px;
        line-height: 20px;
        margin: 0;
      }

      .value {
        font-size: 20px;
        margin-top: 8px;
        font-weight: bold;
        color: rgb(51, 51, 51);
      }
    }
  }
}

.setting-item {
  display: flex;
  font-size: 14px;
  line-height: 20px;
  min-height: 44px;
  padding: 12px 16px;
  width: 50%;
  float: left;

  label {
    color: #333;
    flex-shrink: 0;
    font-weight: bold;
    margin-right: 24px;
    width: 80px;
  }

  .display-value {
    color: #333;
    flex: 1 1;
  }
}

.footer {
  position: fixed;
  bottom: 0px;
  background: #fff;
  height: 80px;
  width: 940px;
  line-height: 80px;
  border-top: 1px solid #eee;

  button {
    margin-right: 10px;
  }
}

.videoimg {
  width: 70px;
  height: 70px;
  border-radius: 3px;
  cursor: pointer;
}

.dialog-left {
  width: 180px;
  float: left;
  padding-top: 20px;
  height: 100%;
  border-right: 1px solid #e5e5e5;
}

.dialog-left ul li {
  margin: 0 auto;
  line-height: 40px;
  font-size: 16px;
  color: #2d3035;
  width: 130px;
  height: 40px;
  border-radius: 3px;
  margin-bottom: 10px;
  text-align: left;
  cursor: pointer;
}

.dialog-center {
  width: 630px;
  float: left;
  padding: 10px 20px;
  color: #242a37;

  ul {
    padding: 0;
    margin: 0;
  }
}

.dialog-right {
  width: 190px;
  float: left;
  padding: 10px;
  color: #939cc0;
  height: 365px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-track-color: transparent;
  -ms-scrollbar-track-color: transparent;
  scrollbar-width: thin;
  border-left: 1px solid #e5e5e5;
}

.dialog-center-title {
  font-size: 16px;
  margin-bottom: 10px;
}

li {
  list-style: none;
}

.dialog-right ul li {
  margin: 0 auto;
  line-height: 30px;
  font-size: 14px;
  color: #13151a;
  width: 184;
  height: 30px;
  border-radius: 3px;
  margin-bottom: 10px;
  text-align: left;
  padding-left: 10px;
  cursor: pointer;
  background: #f2f2f2;
  position: relative;
}

.dialog-right ul li span {
  float: right;
  margin-right: 10px;
}

.dialog-center ul li {
  width: 25%;
  margin-bottom: 10px;
  float: left;
}

.dialog-right ul {
  margin: 0;
  padding: 0;
}

.yAxis {
  display: flex;
  align-items: center;
  justify-content: center;

  input {
    width: 145px;
    // background: #F2F2F2;
    border-radius: 5px;
    // border: none;
  }

  & > div {
    display: flex;
    align-items: center;
  }

  section {
    width: 13px;
    height: 12px;
    background: #ff4d4f;
    border-radius: 3px;
    margin-right: 10px;
  }

  & > div:nth-child(1) {
    margin-right: 35px;

    section {
      background-color: #1890ff;
    }
  }
}

.yAxis + .totops {
  height: 0;
  opacity: 0;
}

/* 在你的CSS文件或<style>标签中添加以下样式 */
/deep/ .ant-table-tbody > tr > td {
  padding: 8px;
  /* 修改单元格间距为10px */
}

/deep/ .ant-table-thead > tr > th {
  padding: 8px;
  /* 修改单元格间距为10px */
}

// css

.ant-card {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03),
    0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 1.5714285714285714;
  list-style: none;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  position: relative;
  background: #ffffff;
  border-radius: 8px;
  border-top: 1px solid #efefef;
}

.acss-14lc1cu {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.acss-1fpsglh {
  margin-top: 8px;
  padding-top: 9px;
  border-top: 1px solid rgba(5, 5, 5, 0.06);
}

.acss-grxbm {
  position: relative;
  width: 100%;
  margin-bottom: 12px;
}

.acss-eji7bv {
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}

.acss-1x0bxe0 {
  font-size: 14px;
  line-height: 22px;
}

.acss-72p16p {
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.88);
}

.acss-qdes8r {
  position: relative;
  top: 4px;
  float: left;
  margin-right: 20px;
}

.acss-1odwksc {
  float: left;
}

.acss-1qoci3j {
  height: 22px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 22px;
}

.acss-18kfphl {
  position: absolute;
  top: 4px;
  right: 0;
  line-height: 1;
  cursor: pointer;
}

.acss-f1zikh {
  height: 38px;
  margin-top: 4px;
  margin-bottom: 0;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.88);
  font-size: 30px;
  line-height: 38px;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
}

.acss-16mkun2 {
  margin-top: 10px;
}

.oc-detail-bar {
  align-items: center;
  background: #f8f8f9;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 2px 16px;
}

.oc-detail-bar .oc-detail-bar-text {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  line-height: 48px;
  margin-bottom: -4px;
  margin-right: -32px;
}

.oc-detail-bar .oc-detail-bar-text .oc-detail-bar-config-item {
  display: flex;
  margin-bottom: 4px;
  margin-right: 62px;
  font-weight: 700;
}

.config-card-container .config-card {
  margin-bottom: 16px;
}

.oc-promotion-detail-card .oc-promotion-detail-card-header {
  align-items: center;
  background: #f8f8f9;
  border-radius: 8px;
  display: flex;
  height: 48px;
  justify-content: space-between;
  padding: 0 16px;
  font-weight: 700;
}

.oc-promotion-detail-card .oc-promotion-detail-card-body {
  margin-top: 8px;
}

.oc-promotion-detail-card
  .oc-promotion-detail-card-body
  .oc-promotion-detail-card-body-item {
  display: flex;
  font-size: 14px;
  line-height: 20px;
  padding: 8px 16px;
}

.oc-promotion-detail-card-body-item {
  display: flex;
  font-size: 14px;
  line-height: 20px;
  padding: 8px 16px;
}
.btn {
  margin-left: 20px;
}
</style>
